import { Controller, useFormContext, useWatch } from 'react-hook-form';
import css from './index.module.scss';
import SelectLabel from '@components/common/select-label';
import { ENQUIRY_INCO_TERMS, PORT_FIELD_TYPES, QUOTE_CONTAINER_TYPE } from '@helpers/constants';
import { AutoComplete, TextField } from '@components/common';
import { getUsaGeoLocationBasedOnZipCode } from '@services/util.service';
import { useEffect } from 'react';
import QuoteCountryField from '../quote-country-field';

const QuoteIncoTerm = (props: any) => {
  const {
    incoTerms,
    incotermWatch,
    portOfLoading,
    portOfLoadingOptions,
    portOfDischarge,
    portOfDischargeOptions,
    incoTermsLocation,
    filterPorts,
    formatPortOptions,
    incoTermsZipCode,
    countryOfOrigin,
    materialLocationCountry,
    incoTermsZipCodeWatch,
    containerSize,
    filterState
  } = props;

  const { control, setValue } = useFormContext();

  useEffect(() => {
    if (incoTermsZipCodeWatch && incoTermsZipCodeWatch.length === 5) {
      getGeoLocation(incoTermsZipCodeWatch);
    }
  }, [incoTermsZipCodeWatch]);

  const getGeoLocation = async (zipCode: string) => {
    const response = await getUsaGeoLocationBasedOnZipCode(zipCode);
    if (response?.data) {
      const { data } = response;
      const placeName = data?.places[0]?.['place name'];
      const state = data?.places[0].state;
      const country = data?.country;
      const location = `${placeName}, ${state}, ${country}`;
      setValue(incoTermsLocation, location);
    } else {
      // notify({
      //   severity: 'error',
      //   message: 'Please enter a valid US Zip Code'
      // });
    }
  };

  const { fcl } = filterState;

  return (
    <>
      <div className={css.rowWrapper}>
        <Controller
          name={incoTerms}
          control={control}
          render={({ field, fieldState }) => (
            <SelectLabel
              {...field}
              required
              options={ENQUIRY_INCO_TERMS}
              label="Inco Terms"
              error={fieldState.invalid}
              helperText={fieldState.error?.message}
            />
          )}
        />
        {incotermWatch?.value === 'FOB' && (
          <Controller
            name={portOfLoading}
            control={control}
            render={({ field, fieldState }) => {
              const onPortSelection = (event: any, param: any) => {
                if (param) {
                  setValue(portOfLoading, param);
                } else {
                  setValue(portOfLoading, null);
                }
              };
              const formattedPortOfLoading = formatPortOptions(portOfLoadingOptions);
              return (
                <AutoComplete
                  {...field}
                  required
                  label="Port Of Loading"
                  placeholder="Start typing"
                  options={formattedPortOfLoading}
                  onInputChange={(event: any, param: any) =>
                    filterPorts(event, param, PORT_FIELD_TYPES.PORT_OF_LOADING)
                  }
                  onInputSelection={onPortSelection}
                  keyOption="label"
                  error={fieldState.invalid}
                  helperText={fieldState.error?.message}
                  rootClassName={css.fieldWrapper1}
                />
              );
            }}
          />
        )}
        {['CIF', 'CNF', 'CFR'].includes(incotermWatch?.value) && (
          <Controller
            name={portOfDischarge}
            control={control}
            render={({ field, fieldState }) => {
              const onPortSelection = (event: any, param: any) => {
                if (param) {
                  setValue(portOfDischarge, param);
                } else {
                  setValue(portOfDischarge, null);
                }
              };
              const formattedPortOfDischarge = formatPortOptions(portOfDischargeOptions);
              return (
                <AutoComplete
                  {...field}
                  required
                  label="Port Of Discharge"
                  placeholder="Start typing"
                  options={formattedPortOfDischarge}
                  onInputChange={(event: any, param: any) =>
                    filterPorts(event, param, PORT_FIELD_TYPES.PORT_OF_DISCHARGE)
                  }
                  onInputSelection={onPortSelection}
                  keyOption="label"
                  error={fieldState.invalid}
                  helperText={fieldState.error?.message}
                  rootClassName={css.fieldWrapper1}
                />
              );
            }}
          />
        )}
        {['EXW'].includes(incotermWatch?.value) && (
          <Controller
            name={incoTermsLocation}
            control={control}
            render={({ field, fieldState }) => {
              let dynamicLabel = 'Inco Terms Location';
              if (incotermWatch?.value === 'EXW') {
                dynamicLabel = 'Ex Works Location';
              }
              return (
                <TextField
                  {...field}
                  required
                  label={dynamicLabel}
                  error={fieldState.invalid}
                  helperText={fieldState.error?.message}
                />
              );
            }}
          />
        )}
        {['DDP', 'DAP'].includes(incotermWatch?.value) && (
          <QuoteCountryField name={countryOfOrigin} label="Country of Origin" />
        )}
      </div>
      <div className={css.rowWrapper}>
        {['DDP', 'DAP'].includes(incotermWatch?.value) && (
          <Controller
            name={incoTermsZipCode}
            control={control}
            render={({ field, fieldState }) => (
              <TextField
                {...field}
                label="Zip Code"
                error={fieldState.invalid}
                helperText={fieldState.error?.message}
              />
            )}
          />
        )}
        {['DDP', 'DAP'].includes(incotermWatch?.value) && (
          <Controller
            name={incoTermsLocation}
            control={control}
            render={({ field, fieldState }) => {
              return (
                <TextField
                  {...field}
                  required
                  label="Place of Discharge"
                  error={fieldState.invalid}
                  helperText={fieldState.error?.message}
                />
              );
            }}
          />
        )}

        {!['DDP', 'DAP'].includes(incotermWatch?.value) && (
          <QuoteCountryField name={countryOfOrigin} label="Country of Origin" />
        )}
        {fcl && !['DDP', 'DAP'].includes(incotermWatch?.value) && (
          <Controller
            name={containerSize}
            control={control}
            render={({ field, fieldState }) => (
              <SelectLabel
                {...field}
                options={QUOTE_CONTAINER_TYPE}
                label="Container Size"
                isClearable
                error={fieldState.invalid}
                helperText={fieldState.error?.message}
              />
            )}
          />
        )}
      </div>
      <div className={css.rowWrapper}>
        <QuoteCountryField name={materialLocationCountry} label="Material Location Country" />
        {fcl && ['DDP', 'DAP'].includes(incotermWatch?.value) ? (
          <Controller
            name={containerSize}
            control={control}
            render={({ field, fieldState }) => (
              <SelectLabel
                {...field}
                options={QUOTE_CONTAINER_TYPE}
                label="Container Size"
                isClearable
                error={fieldState.invalid}
                helperText={fieldState.error?.message}
              />
            )}
          />
        ) : (
          <div />
        )}
      </div>
    </>
  );
};

export default QuoteIncoTerm;
